import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import Button from "../../Components/Button";
import styles from "./styles.module.scss";
import { getTourAvailabilities } from "../Services/EnquiryService";

type IStartEnquiryProps = {
    [key: string]: any;
};

type Slot = {
    date: string;
    label: string;
    slot: string;
    active: boolean;
};

const formatDate = (dateString) => {
    const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];

    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    const date = new Date(dateString);
    const dayCode = days[date.getDay()];
    const day = date.getDate().toString().padStart(2, "0");
    const month = months[date.getMonth()];

    return { dayCode, day, month };
};

function PickTimePersonTourBooking(props: IStartEnquiryProps) {
    const { enquiryDetail } = props;
    const [liveTourInfo, setLiveTourInfo] = useState(
        enquiryDetail.pickerTimePersonTour
    );
    const [loading, setLoading] = useState(false);
    const [dateIndex, setDateIndex] = useState(0);
    const [timeActive, setTimeActive] = useState(-1);
    useEffect(() => {
        props.sendEventGa4({
            eventName: "enquiry_workflow",
            Action: "start",
            FormStep: "book a tour",
            ListingType: props.listingType,
        });
    }, []);
    useEffect(() => {
        let availabilityDetailsObject = transformData(
            liveTourInfo.availabilityDetailsResponse,
            liveTourInfo.startDate,
            liveTourInfo.endDate
        );
        const firstActiveIndex = availabilityDetailsObject.findIndex(
            (item) => item.times.length > 0
        );
        const itemActivated = liveTourInfo.availabilityDetails.some(
            (item) => item.active
        );
        setTimeActive(() => (itemActivated ? 1 : -1));

        setLiveTourInfo((prev) => {
            return {
                ...prev,
                availabilityDetails: availabilityDetailsObject.map((item, index) => ({
                    ...item,
                    active: !itemActivated
                        ? index === firstActiveIndex
                        : enquiryDetail.pickerTimePersonTour.availabilityDetails[index]
                            ?.active,
                    times:
                        enquiryDetail.pickerTimePersonTour.availabilityDetails[index]
                            ?.times || availabilityDetailsObject[index]?.times,
                })),
            };
        });
    }, [enquiryDetail.pickerTimePersonTour]);

    const formatTime = (dateTime) => {
        const date = new Date(dateTime);
        const options: Intl.DateTimeFormatOptions = {
            hour: "numeric",
            minute: "numeric",
            hour12: true,
        };
        return date.toLocaleTimeString("en-US", options);
    };

    const transformData = (data, sDate, eDate) => {
        const startDate = new Date(sDate);
        const endDate = new Date(eDate);
        const availabilityDetails = [];
        for (const availability of data) {
            const startTime = new Date(availability.startTime);
            const endTime = new Date(availability.endTime);
            const date = availability.startTime.slice(0, 10);

            if (startTime >= startDate && endTime < endDate) {
                const time = {
                    date,
                    label: formatTime(startTime),
                    slot: availability.startTime,
                    active: false,
                };

                const existingDate = availabilityDetails.find(
                    (item) => item.date === date
                );

                if (existingDate) {
                    existingDate.times.push(time);
                } else {
                    availabilityDetails.push({
                        date,
                        times: [time],
                    });
                }
            }
        }

        var data: any = [];

        while (startDate <= endDate) {
            var formattedDate = startDate.toISOString().slice(0, 10);
            var timesDetail = availabilityDetails.find(
                (x) => x.date == formattedDate
            );
            data.push({
                date: formattedDate,
                format: formatDate(formattedDate),
                times: timesDetail != null ? timesDetail.times : [],
                active: false,
            });
            startDate.setDate(startDate.getDate() + 1);
        }
        return data;
    };

    const loadMoreDates = (type) => {
        const baseDate = liveTourInfo.startDate ? new Date(liveTourInfo.startDate) : new Date();
        let newStartDate;

        if (type === 1) {
            setDateIndex(dateIndex + 1);
            newStartDate = new Date(baseDate.setDate(baseDate.getDate() + 7));
        } else if (type === -1 && dateIndex > 0) {
            setDateIndex(dateIndex - 1);
            newStartDate = new Date(baseDate.setDate(baseDate.getDate() - 7));
        } else {
            return;
        }

        const newEndDate = new Date(newStartDate);
        newEndDate.setDate(newEndDate.getDate() + 6);

        const _startDateStr = newStartDate.toLocaleDateString("en-CA");
        const _endDateStr = newEndDate.toLocaleDateString("en-CA");

        setLiveTourInfo(prev => ({
            ...prev,
            startDate: _startDateStr,
            endDate: _endDateStr,
        }));

        setLoading(true);


        getTourAvailabilities(_startDateStr, _endDateStr, props.token)
            .then((res: any) => {
                setLiveTourInfo((prev) => ({
                    ...prev,
                    isBackDateTimeExists: dateIndex > 0,
                }));

                let availabilityDetailsObject = transformData(
                    res.data.availabilityDetails,
                    _startDateStr,
                    _endDateStr
                );

                setLiveTourInfo((prev) => ({
                    ...prev,
                    availabilityDetails: availabilityDetailsObject,
                    isDateTimeApiLoading: false,
                }));
            })
            .catch((error) => {
                setLiveTourInfo((prev) => ({
                    ...prev,
                    isDateTimeApiLoading: false,
                }));
            })
            .finally(() => {
                setLoading(false);
                setTimeActive(-1);
            });
    };

    const sortSlotsByAscending = (slots: Slot[]): Slot[] => {
        return [...slots].sort((a, b) => {
            const timeA = a.label;
            const timeB = b.label;
            function parseTime(timeStr) {
                const [hours, minutes] = timeStr.split(":");
                let hour = parseInt(hours);
                if (timeStr.includes("PM") && hour !== 12) {
                    hour += 12;
                } else if (timeStr.includes("AM") && hour === 12) {
                    hour = 0;
                }
                return hour * 60 + parseInt(minutes);
            }
            return parseTime(timeA) - parseTime(timeB);
        });
    };

    const selectBookingDate = (index) => {
        let updatedData = JSON.parse(JSON.stringify(liveTourInfo));
        updatedData.availabilityDetails.map((item) => {
            item.active = false;
        });

        if (updatedData.availabilityDetails[index].times.length > 0) {
            updatedData.availabilityDetails[index].active = true;
        }
        setTimeActive(-1);
        setLiveTourInfo(updatedData);
    };

    const isFormValid = () => {
        let isValidData = true;
        if (!liveTourInfo?.availabilityDetails.some((key) => key.active)) {
            isValidData = false;
        }
        liveTourInfo?.availabilityDetails.map((item, index) => {
            if (item.active && !item.times.some((key) => key.active)) {
                isValidData = false;
            }
        });
        return isValidData;
    };

    const onSubmit = () => {
        if (!isFormValid()) return;
        let tourDate;
        let tourTime;
        let slot;

        liveTourInfo?.availabilityDetails.map((item, index) => {
            if (item.active) {
                tourDate = item.date;
                item.times.map((time) => {
                    if (time.active) {
                        tourTime = time.label;
                        slot = time.slot;
                    }
                });
            }
        });
        props.sendEventGa4({
            eventName: "enquiry_workflow",
            Action: "finish",
            FormStep: "book a tour",
            ListingType: props.listingType,
        });

        props.setDataEnquiry((prev) => ({
            ...prev,
            pickerTimePersonTour: {
                ...prev.pickerTimePersonTour,
                ...liveTourInfo,
            },
            chooseTime: {
                tourDate,
                tourTime,
                slot,
            },
        }));

        props.onNext({
            data: null,
        });
    };
    const handleChange = (dateIndex, event) => {
        const timeIndex = Number(event.target.value);
        try {
            let updatedData = JSON.parse(JSON.stringify(liveTourInfo));
            updatedData.availabilityDetails.map((item) => {
                item.times.map((time) => {
                    time.active = false;
                });
            });
            updatedData.availabilityDetails[dateIndex].times[timeIndex].active = true;
            setLiveTourInfo(updatedData);
            setTimeActive(timeIndex);
        } catch (error) {
            console.log("error", error);
        }
    };

    return (
        <div className="text-[#484554] pb-24 lg:pb-0">
            <h2 className="text-[22px] font-semibold leading-7 mb-[32px] text-[#484554]">
                Choose a time for your tour
            </h2>
            <div className="relative">
                {loading && (
                    <div
                        className="absolute inset-0 flex items-center justify-center bg-white z-10 w-full"
                        style={{ backgroundColor: `rgba(255, 255, 255, 0.5` }}
                    >
                        <span className="flex items-center gap-2">
                            <img
                                className="mix-blend-multiply"
                                src="/img/navy-spinner.svg"
                                alt="Spinner white dots circle"
                            />
                        </span>
                    </div>
                )}
                <div className="flex items-center space-x-2 rounded-lg mx-auto justify-center">
                    {liveTourInfo?.startDate !==
                        new Date().toISOString().slice(0, 10) && (
                            <Icon
                                icon="mingcute:left-line"
                                onClick={() => {
                                    if (loading) return;
                                    props.sendEventGa4({
                                        eventName: "enquiry_workflow_feature",
                                        FeatureName: "previous calendar slider",
                                    });
                                    loadMoreDates(-1);
                                }}
                                className={`text-black-1 cursor-pointer icon ${loading ? "opacity-50 cursor-not-allowed" : ""
                                    }`}
                                style={{ minWidth: "1.5rem" }}
                            ></Icon>
                        )}
                    <ul className="relative flex gap-2 relative overflow-auto w-fit">
                        {liveTourInfo?.availabilityDetails
                            .slice(0, 7)
                            .map((item, index) => (
                                <li
                                    key={index}
                                    onClick={() => selectBookingDate(index)}
                                    className={`${item.active ? "border-[#5A60EC] bg-[#EEF2FF]" : ""
                                        } ${item.times?.length > 0
                                            ? "bg-[#F9F7F3] cursor-pointer"
                                            : "pointer-events-none cursor-not-allowed bg-[#EEEDF1]"
                                        } border w-[80px] whitespace-nowrap text-[12px] flex flex-col items-center justify-center px-4 py-2 rounded-lg`}
                                >
                                    <span
                                        className={`font-semibold ${item.times.length > 0
                                            ? "text-[#5A60EC]"
                                            : "text-[#B8B6C3]"
                                            }`}
                                    >
                                        {item.format.dayCode}
                                    </span>
                                    <span
                                        className={`font-medium ${item.times.length > 0
                                            ? "text-[#484554]"
                                            : "text-[#B8B6C3]"
                                            }`}
                                    >{`${item.format.day} ${item.format.month}`}</span>
                                </li>
                            ))}
                    </ul>
                    <Icon
                        icon="mingcute:right-line"
                        onClick={() => {
                            if (loading) return;
                            props.sendEventGa4({
                                eventName: "enquiry_workflow_feature",
                                FeatureName: "next calendar slider",
                            });
                            loadMoreDates(1);
                        }}
                        className={`text-black-1 cursor-pointer icon`}
                        style={{ minWidth: "1.5rem" }}
                    ></Icon>
                </div>
            </div>

            <ul className="pt-4 space-y-2">
                {!loading &&
                    liveTourInfo?.availabilityDetails.map(
                        (item: any, dateIndex: number) => {
                            const result = sortSlotsByAscending(item.times);
                            return (
                                <React.Fragment key={item.date}>
                                    {item.active &&
                                        result.map((time, timeIndex) => {
                                            return (
                                                <li key={`${item.date}-${time.slot}`}>
                                                    <label
                                                        className={`${styles.dateRadioCustom} py-[15px] border border-[#F7F7F8] text-[12px] font-semibold p-4 rounded-md bg-[#F9F7F3] text-[#5A60EC] leading-[16px] flex justify-between items-center`}
                                                    >
                                                        {time.label}
                                                        <input
                                                            onChange={(e) => handleChange(dateIndex, e)}
                                                            type="radio"
                                                            name="time"
                                                            id={`time-${dateIndex}-${timeIndex}`}
                                                            value={timeIndex}
                                                            checked={time.active}
                                                            className={`${styles.myRadio} rounded-full`}
                                                        />
                                                    </label>
                                                </li>
                                            );
                                        })}
                                </React.Fragment>
                            );
                        }
                    )}
            </ul>
            <div className="fixed bottom-0 left-0 right-0 bg-white p-4 md:pt-10 border-t border-gray-200 flex justify-center z-10 lg:static lg:bg-transparent lg:border-0 lg:justify-center lg:ml-[-34px]">
                <Button
                    disabled={timeActive < 0}
                    form="children-detail-form"
                    onClick={onSubmit}
                    customClass={`w-full lg:w-fit my-0 lg:md:mb-0 ${timeActive < 0 ? "pointer-events-none cursor-not-allowed" : ""
                        } select-date next-button`}
                    variant="primary"
                >
                    Finish
                </Button>
            </div>
        </div>
    );
}

export default PickTimePersonTourBooking;
